module.exports = __webpack_public_path__ + "static/media/poster.d70e39cf.png";